import { render, staticRenderFns } from "./404.vue?vue&type=template&id=ce5ae064&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=ce5ae064&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5ae064",
  null
  
)

export default component.exports